import { create } from 'zustand';

/** Кнопка в уведомлении («Открыть»). */
export interface ToastAction {
  label: string;
  run: () => void;
}

interface ToastState {
  text: string | null;
  action: ToastAction | null;
  show: (text: string, ms?: number, action?: ToastAction) => void;
  hide: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

/** Короткое сообщение внизу экрана («скоро», «не удалось»); по желанию — с кнопкой. */
export const useToast = create<ToastState>((set) => ({
  text: null,
  action: null,
  show: (text, ms = 2200, action) => {
    if (timer) clearTimeout(timer);
    set({ text, action: action ?? null });
    timer = setTimeout(() => set({ text: null, action: null }), ms);
  },
  hide: () => {
    if (timer) clearTimeout(timer);
    set({ text: null, action: null });
  },
}));
